<div class="container">
  <div class="wrapper">
    <div class="header">
      <div class="top-heading">
        <div class="logo text-align-center"></div>
        <br />
        <h6 class="side-title" id="brand-heading" [innerHTML]="translate('label.gb.title.merlin.pcn')"></h6>
      </div>
      <hr class="topper" />
      <hr class="divider" />
    </div>
    <div id="loginWrapper">
      <div id="loginContentArea">
        <div class="page-title">
          <div class="ssn_page_title" id="page-title" [innerHTML]="translate('label.gb.establish_account_security')"></div>
          <hr class="hrLogin" />
        </div>
        <div class="page-wrapper">
          <div class="page-top-content">
            <div id="top-content" class="content" [innerHTML]="translate('msg.account_security_instruction_text')"></div>
            <br />
            <hr class="content-hr" />
          </div>
          <div class="error-box">
            @if (submitted && getReqFieldsErrors().length > 0) {
              <div class="error pageLevel" id="ReqFieldsErrors">
                <div [innerHTML]="translateEmailError()"></div>
                <ul>
                  @for (fieldName of getReqFieldsErrors(); track fieldName) {
                    <li>{{fieldName}}</li>
                  }
                </ul>
              </div>
            }
            @if (submitted && getInvalidFieldsErrors().length > 0) {
              <div class="error pageLevel" id="InvalidFieldsErrors">
                <div [innerHTML]="translateEmailInvalidError()"></div>
                <ul>
                  @for (fieldName of getInvalidFieldsErrors(); track fieldName) {
                    <li>{{fieldName}}</li>
                  }
                </ul>
              </div>
            }
            @if (submitted && genError) {
              <div class="">
                <div id="invalidGenPhoneNumber" class="error pageLevel">
                  <div [innerHTML]="translateGenError()"></div>
                </div>
              </div>
            }
            @if (errorMsgEmail) {
              <div [innerHTML]="translateErrorMsgEmail()" id="alternateEmailalreadyExist"
              class="error pageLevel"></div>
            }
          </div>
          <form [formGroup]="otwForm" (ngSubmit)="onSubmit(otwForm)">
            <div id="api">
              <div class="column-box left-box">
                <div class="input-section">
                  <div class="label-box">{{ 'label.gb.email' | translate }} :</div>
                  <div class="input-box">
                    <input type="email" formControlName="emailAddress" [ngClass]="{'input-error': submitted && otwForm.get('emailAddress').errors}"
                      class="primary-email" id="primary-email">
                    </div>
                    <div class="tooltip question-img-box" [mdePopoverTriggerFor]="dataRatesPopover3">
                      <img src="assets/images/question.png" class="question-img">
                    </div>
                    <mde-popover #dataRatesPopover3="mdePopover" [mdePopoverOverlapTrigger]="false"
                      mdePopoverPositionX="after" mdePopoverPositionY="above"
                      mdePopoverArrowOffsetX="15">
                      <mat-card appearance="outlined">
                        <mat-card-content>
                                                <p [innerHTML]="
                                            translateEmailTooltip()
                                        " [id]="
                                            identifierService.labelId(
                                                'contactInofrmation',
                                                'emailTooltip'
                                            )
                                        "></p>
                        </mat-card-content>
                      </mat-card>
                    </mde-popover>
                  </div>
                  <div class="input-section">
                    <div class="label-box alt-email">{{ 'label.gb.second_email' | translate }} * :</div>
                    <div class="input-box">
                      <input type="email" formControlName="mfaEmailAddress" [ngClass]="{'input-error': submitted && otwForm.get('mfaEmailAddress').errors}"
                        class="alternate-email" id="alternate-email">
                      </div>
                      <div class="tooltip question-img-box" [mdePopoverTriggerFor]="dataRatesPopover1">
                        <img src="assets/images/question.png" class="question-img">
                      </div>
                      <mde-popover #dataRatesPopover1="mdePopover" [mdePopoverOverlapTrigger]="false" mdePopoverPositionX="after" mdePopoverPositionY="above" mdePopoverArrowOffsetX="15">
                        <mat-card appearance="outlined" style="max-width: 500px">
                          <mat-card-content>
                            <p [innerHTML]="alternateEmailTooltip()"
                                                    [id]="
                                                        identifierService.labelId(
                                                            'contactInofrmation',
                                                            'alternateEmailTooltip'
                                                        )
                                                    "></p>
                          </mat-card-content>
                        </mat-card>
                      </mde-popover>
                    </div>
                    <div class="button-section">
                      <button mat-raised-button color="primary" class="merlin-button" id="save" type="submit">
                        {{ 'label.gb.save' | translate }}
                      </button>
                    </div>
                  </div>
                  <div class="column-box rigt-box">
                    @if (secondaryPhone || mainPhone || smsPhone) {
                      <div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="checkbox-header tooltip">{{ 'label.gb.text_message' | translate }}
                              <img src="assets/images/question.png" [mdePopoverTriggerFor]="dataRatesPopover2" class="question-img">
                            </div>
                            <mde-popover #dataRatesPopover2="mdePopover" [mdePopoverOverlapTrigger]="false" mdePopoverPositionX="after" mdePopoverPositionY="above" mdePopoverArrowOffsetX="15">
                              <mat-card appearance="outlined" style="max-width: 500px">
                                <mat-card-content>
                                                        <p [innerHTML]="
                                                                getTooltip(
                                                                    'label.gb.text_msg_tooltip'
                                                                )
                                                            " [id]="
                                                                identifierService.labelId(
                                                                    'contactInofrmation',
                                                                    'emailTooltip'
                                                                )
                                                            "></p>
                                </mat-card-content>
                              </mat-card>
                            </mde-popover>
                          </div>
                          <div class="col-md-4">
                            <div class="checkbox-header tooltip">{{ 'label.gb.phone_authentication' | translate }}
                              <img src="assets/images/question.png" [mdePopoverTriggerFor]="authenticationPopover" class="question-img">
                            </div>
                            <mde-popover #authenticationPopover="mdePopover" [mdePopoverOverlapTrigger]="false" mdePopoverPositionX="after" mdePopoverPositionY="above" mdePopoverArrowOffsetX="15">
                              <mat-card appearance="outlined" style="max-width: 500px">
                                <mat-card-content>
                                                        <p [innerHTML]="
                                                                getTooltip(
                                                                    'label.gb.phone_authentication_tooltip'
                                                                )
                                                            " [id]="
                                                                identifierService.labelId(
                                                                    'contactInofrmation',
                                                                    'emailTooltip'
                                                                )
                                                            "></p>
                                </mat-card-content>
                              </mat-card>
                            </mde-popover>
                          </div>
                        </div>
                        @if (mainPhone) {
                          <div class="row mobile-section">
                            <div class="col-md-4" >
                              <label> {{mainPhone}}</label>
                            </div>
                            <div class="col-md-4 text-center">
                              <input type="checkbox" class="mobile-checkbox checkbox-align" (change)="checkboxCondition()" formControlName="mainPhone" id="" [value]="mainPhone">
                            </div>
                          </div>
                        }
                        @if (secondaryPhone) {
                          <div class="row mobile-section">
                            <div class="col-md-4">
                              <label> {{secondaryPhone}}</label>
                            </div>
                            <div class="col-md-4 text-center">
                              <input type="checkbox" class="mobile-checkbox checkbox-align" (change)="checkboxCondition()"
                                formControlName="secondaryPhone" id="" [value]="secondaryPhone">
                              </div>
                            </div>
                          }
                          @if (smsPhone) {
                            <div class="row mobile-section">
                              <div class="col-md-4">
                                <label> {{smsPhone}}</label>
                              </div>
                              <div class="col-md-4 text-center">
                                <input type="checkbox" class="mobile-checkbox checkbox-align" (change)="checkboxCondition()"
                                  formControlName="smsPhone" id="" [value]="smsPhone">
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- <div class="footerSpace"> -->
            <merlin-footer class="termsFooter" [footerData]="footerData" [copyRights]="footerCopyRights"
            [footerClass]="fooMenuClass" [copyrightClass]=""></merlin-footer>
          <!-- </div> -->
        </div>
      </div>